// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__17Frg","select":"Header_select__14mQt","clinic":"Header_clinic__21hfU"};